import * as React from 'react'
import { useSelector } from 'react-redux'
import { getActiveAccountSlug } from 'auth/selectors'
import './styles.scss'

function PosTerminals() {
    const accountSlug = useSelector(getActiveAccountSlug)

    return (
        <div className="pos-iframe-wrapper">
            <iframe
                src={`https://convious.com/embed/pos${
                    accountSlug ? `?account=${encodeURIComponent(accountSlug)}` : ''
                }`}
                title="Point of Sale"
            />
        </div>
    )
}

export default PosTerminals
